import Vue from "vue";

Vue.filter('abs', function (v, forceZero) {
    if (v === null || v === undefined || (forceZero !== true && v === 0) || typeof v !== "number") return '';
    return Math.abs(v);
});